import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import NavbarLayout from './pages/NavbarLayout';
import OrderSuccess from './pages/PurchaseSection/OrderSuccess';


function App() {
  return (
    <div className="App">
      <div>
        <div>
          <Router>
            <Routes>
              {/* <Route index element={<Video/>}/> */}
              <Route path='/' element={<NavbarLayout/>}/>
              <Route path="/order-success" element={<OrderSuccess />} />
            </Routes>
          </Router>
          
        </div>
      </div>
    </div>
  );
}

export default App;
